// extracted by mini-css-extract-plugin
module.exports = {"mainFooter":"style_mainFooter__1tm4P"};